import React, { Component } from "react";
import styles from"./Anchor.module.css";

class Anchor extends Component {
  render() {
    return (
      <a
        href={this.props.url}
        target={this.props.target}
        className={styles.title}
        rel="noreferrer"
      >
        {this.props.title}
      </a>
    );
  }
}

export default Anchor;
